const fixAmAndPm = (dateObject) => {
    const stringLength = dateObject.length;
    return dateObject.slice(0, stringLength - 1);
}

export default fixAmAndPm;



// WEBPACK FOOTER //
// ./src/utils/fixAmAndPm.js